import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  GetBorrowerPaneWidth,
  SetBorrowerPaneWidth
} from 'ng2-app/modules/today/state/today-page-state/today-page.action';

export class TodayPageStateModel {
  borrowerPaneWidth: number;
}

@State<TodayPageStateModel>({
  name: 'TodayPage',
  defaults: {
    borrowerPaneWidth: 50
  }
})
@Injectable()
export class TodayPageState {

  @Selector()
  static borrowerPaneWidth( state: TodayPageStateModel ) {
    return state.borrowerPaneWidth;
  }

  constructor(
  ) {}

  @Action( GetBorrowerPaneWidth )
  getBorrowerPaneWidth(
    { getState, setState }: StateContext<TodayPageStateModel>,
    { }: GetBorrowerPaneWidth
  ) {
    const currentWidth = getState().borrowerPaneWidth;
    const borrowerPaneWidth = parseFloat(localStorage.getItem('borrowerPaneWidth') || '') || currentWidth;
    setState({borrowerPaneWidth});
  }

  @Action( SetBorrowerPaneWidth )
  setBorrowerPaneWidth(
    { setState }: StateContext<TodayPageStateModel>,
    { borrowerPaneWidth }: SetBorrowerPaneWidth
  ) {
    localStorage.setItem('borrowerPaneWidth', borrowerPaneWidth.toString());
    setState({ borrowerPaneWidth });
  }

}
